
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shoppingbag",
      function () {
        return require("private-next-pages/shoppingbag/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shoppingbag"])
      });
    }
  